import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=9c2c1f26&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=9c2c1f26&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2c1f26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c2c1f26')) {
      api.createRecord('9c2c1f26', component.options)
    } else {
      api.reload('9c2c1f26', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=9c2c1f26&scoped=true", function () {
      api.rerender('9c2c1f26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/Tabs.vue"
export default component.exports